module.exports = __webpack_public_path__ + "img/jita_down_code.b8c66dd1.png";